/* eslint-disable react/prop-types */
import ComposedViewOneComponent from "./composed-view-one";
import { useHistory } from "react-router-dom";
function ComposedViewOne({
  header,
  title,
  subTitle,
  content,
  image,
  button,
  reverse,
  className,
}) {
  const history = useHistory();

  const handleClick = () => {
    let path = button.link;
    history.push(path);
  };

  return (
    <ComposedViewOneComponent
      header={header}
      title={title}
      subTitle={subTitle}
      content={content}
      image={image}
      button={button}
      reverse={reverse}
      onClick={handleClick}
      className={className}
    />
  );
}

export default ComposedViewOne;
